import { ANALYSIS_CLASSIFICATION } from "../consts";

export const getCuckooAndCapeClassification = (
  unknownLimit,
  suspiciousLimit,
  score
) => {
  if (score <= unknownLimit) return ANALYSIS_CLASSIFICATION.UNKNOWN;
  if (score > unknownLimit && score < suspiciousLimit)
    return ANALYSIS_CLASSIFICATION.SUSPICIOUS;
  return ANALYSIS_CLASSIFICATION.MALICIOUS;
};

export const prepareHelpMessage = data => {
  if (data.isConfigured === false) {
    return "Not Configured";
  }
  if (data.fileTypeSupported === false) {
    return "File Type Not Supported";
  }
  if (data.fileOversized) {
    return "File Oversized";
  }
  return "";
};
